/*
  Colour swatches on a product card. They are buttons, never links: clicking
  one swaps the card's image to that colour's variant photo and repoints the
  card's own links at that variant, without navigating anywhere. The hover
  (second) image is removed once a colour is chosen, so hovering can't reveal
  a different colour's photo.
*/
if (!customElements.get('card-swatches')) {
  customElements.define(
    'card-swatches',
    class CardSwatches extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.onClick.bind(this));
      }

      get card() {
        return this.closest('.card-wrapper') || this.closest('.card');
      }

      onClick(event) {
        const button = event.target.closest('.card__swatch-link');
        if (!button) return;

        const card = this.card;
        if (!card) return;

        const media = card.querySelector('.card__media .media');
        const image = media && media.querySelector('img');

        if (image && button.dataset.cardImage) {
          if (!this.secondaryImage) {
            this.secondaryImage = media.querySelector('img + img');
          }
          if (this.secondaryImage && this.secondaryImage.parentNode) {
            this.secondaryImage.remove();
          }

          image.srcset = button.dataset.cardSrcset || '';
          image.src = button.dataset.cardImage;
          if (button.dataset.cardAlt) image.alt = button.dataset.cardAlt;
        }

        const variantUrl = button.dataset.variantUrl;
        if (variantUrl) {
          card.querySelectorAll('a.full-unstyled-link, a.card__heading-link').forEach((cardLink) => {
            cardLink.href = variantUrl;
          });
        }

        this.querySelectorAll('.card__swatch-link').forEach((swatch) => {
          const isActive = swatch === button;
          swatch.classList.toggle('is-active', isActive);
          swatch.setAttribute('aria-pressed', String(isActive));
        });
      }
    }
  );
}
